// extracted by mini-css-extract-plugin
export var actionButton = "_5n-1";
export var actionButtons = "_5n-2";
export var actions = "_5n-0";
export var aiUnread = "_5n-10";
export var alignCenter = "_5n-h";
export var backWrapper = "_5n-3";
export var cellContainer = "_5n-4";
export var checkboxContainer = "_5n-5";
export var contentContainer = "_5n-6";
export var contentHeader = "_5n-8";
export var conversationsTableWrapper = "_5n-s";
export var draftReplyBadgeContainer = "_5n-m";
export var dropdownItem = "_5n-b";
export var dropdownItemsContainer = "_5n-a";
export var dropdownTitle = "_5n-c";
export var errorIcon = "_5n-7";
export var filter = "_5n-d";
export var gray = "_5n-i";
export var headerActionButtons = "_5n-e";
export var headerCheckboxContainer = "_5n-f";
export var icon = "_5n-j";
export var menuContainer = "_5n-k";
export var noMoreTicketsIcon = "_5n-12";
export var noMoreTicketsSubText = "_5n-13";
export var oneLine = "_5n-l";
export var optionsButton = "_5n-n";
export var plus = "_5n-o";
export var portalButtonsWrapper = "_5n-g";
export var red = "_5n-p";
export var scrolledTop = "_5n-9";
export var search = "_5n-q";
export var selectedConversationsCount = "_5n-r";
export var spinner = "_5n-t";
export var strong = "_5n-u";
export var summaryCell = "_5n-v";
export var tableContainer = "_5n-11";
export var tagContainer = "_5n-w";
export var threeDots = "_5n-x";
export var twoLines = "_5n-y";
export var unread = "_5n-z";